import { render } from "./FilingWorkflow.vue?vue&type=template&id=2b7b2768&scoped=true"
import script from "./FilingWorkflow.vue?vue&type=script&lang=js"
export * from "./FilingWorkflow.vue?vue&type=script&lang=js"

import "./FilingWorkflow.vue?vue&type=style&index=0&id=2b7b2768&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7b2768"]])

export default __exports__